<div class="atlas-profile-search-actions" *ngIf="searchResult">
  <div class="mct-flex mct-row mct-gap-10">
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-flex-1-1-100px">
      <action-button
        data-cy="btnProfileSearchActions"
        [label]="actionsText"
        [items]="actionsOptions"
        [menuStyle]="{ width: '325px', 'max-width': '85vw' }"
      >
      </action-button>
      <wl-busy [show]="isExporting"></wl-busy>
    </div>

    <div class="mct-flex mct-justify-end-gt-sm mct-items-center-gt-sm mct-gap-10 profile-selector-flex mct-col-lt-sm" style="width: 100%">
      &nbsp;
      <div class="mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-flex-1-1-0">
        {{ 'profiles.search.there-are' | translate | ucfirst }}
        <span style="font-weight: bold"> &nbsp; {{ selectedCount }} {{ 'profiles.search.tagged-profiles' | translate }}&nbsp; </span>
        {{ 'profiles.search.to-take-action' | translate }}
      </div>
      <div class="mct-flex mct-row mct-wrap mct-justify-end mct-items-center mct-flex-1-1-0">
        {{ 'profiles.search.search-returned' | translate | ucfirst }}&nbsp;
        <span style="font-weight: bold"> {{ this.searchResult.TotalCount }}&nbsp;{{ 'profiles.search.total-profiles' | translate }}</span>
      </div>
    </div>

    <div class="ml-27 mct-flex mct-row mct-justify-end mct-items-center mct-flex-1-0-300px">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-default tall"
        style="white-space: nowrap"
        (click)="clearSearch()"
        icon="pi pi-times"
        [label]="'profiles.search.clear' | translate | uppercase"
      ></button>
      <button
        app-add-button
        *wlHasBetaFeature="'ProfileSelectorConfig'"
        class="atlas-btn atlas-btn-primary tall"
        style="white-space: nowrap"
        [label]="'profiles.search.manage-columns.title' | translate | titlecase"
        (click)="openColumnConfig()"
      ></button>
    </div>
  </div>
</div>

<div #profilesGridScrollPosition></div>

<div [hidden]="hideTable" *ngIf="searchResult" class="table-container">
  <p-table
    [showGridlines]="true"
    #profilesDataGrid
    [columns]="columnNames"
    [value]="searchResult.Result"
    [paginator]="true"
    [rows]="searchResult.PageSize"
    [totalRecords]="searchResult.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [lazyLoadOnInit]="false"
    [scrollable]="true"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>
          <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
        </th>
        <th class="t-ac w-3">
          {{ 'common.edit' | translate | titlecase }}
        </th>
        <th style="min-width: 220px" [pSortableColumn]="'Profile Name'">
          {{ 'common.personal-information.profile-name' | translate | titlecase }}
          <p-sortIcon field="Profile Name"></p-sortIcon>
        </th>
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col"
          [pSortableColumnDisabled]="col === 'Related Organization'"
          [ngStyle]="{ 'min-width': col == 'ProfileID' ? '120px' : '150px' }"
        >
          {{ col }}
          <p-sortIcon *ngIf="col !== 'Related Organization'" [field]="col"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td>
          <p-checkbox binary="true" [ngModel]="itemIsSelected(rowData)" (ngModelChange)="onRowSelectionChange(rowData)"></p-checkbox>
        </td>
        <td class="t-ac">
          <a class="cursor-pointer" (click)="onEditClicked(rowData.ProfileID)">
            <span class="pi pi-pencil"></span>
          </a>
        </td>
        <td>
          <wl-profile-type-icon
            *ngIf="rowData?.ProfileID"
            [isMember]="rowData.Member"
            [isOrg]="rowData['Org Indicator']"
            [profileId]="rowData.ProfileID"
          >
          </wl-profile-type-icon>
          <a class="cursor-pointer" (click)="navigateToProfile(rowData.ProfileID)">{{ rowData['Profile Name'] }}</a>
        </td>
        <td *ngFor="let col of columns; index as i">
          <div *ngIf="profileSelectorColumnMetaData?.[i]?.DataType == dataTypeEnum.String">
            {{ rowData[col] }}
          </div>
          <div class="t-ac" *ngIf="profileSelectorColumnMetaData?.[i]?.DataType == dataTypeEnum.Boolean">
            <p-checkbox [disabled]="true" [ngModel]="!!rowData[col]" [binary]="true"></p-checkbox>
          </div>
          <div class="t-ac" *ngIf="profileSelectorColumnMetaData?.[i]?.DataType == dataTypeEnum.SubscriptionStatus">
            {{
              rowData[col]
                ? ('profiles.search.advanced.options.opted-out' | translate | titlecase)
                : ('profiles.search.advanced.options.opted-in' | translate | titlecase)
            }}
          </div>
          <div *ngIf="profileSelectorColumnMetaData?.[i]?.DataType == dataTypeEnum.Email">
            <a [href]="'mailto:' + rowData[col]" target="_blank">{{ rowData[col] }}</a>
          </div>
          <div *ngIf="profileSelectorColumnMetaData?.[i]?.DataType == dataTypeEnum.Date">
            {{ rowData[col] | date: 'MM/dd/yyyy' }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]" (pageSizeChange)="pageSizeChanged()">
  </wl-page-size-dropdown>
</div>
<wl-multiple-profile-invoice-modal></wl-multiple-profile-invoice-modal>
<p-dialog [visible]="showAffCodeAddDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <ng-template pTemplate="header">
    {{ 'profiles.search.affcode-add-header' | translate }}
  </ng-template>
  <wl-affcode-mass-add #wlAffCodeMassAdd hideTypes="true" showButtons="false"></wl-affcode-mass-add>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        type="button"
        pButton
        class="atlas-btn atlas-btn-primary"
        [label]="'common.add' | translate | titlecase"
        (click)="massAddAffCodes()"
        [disabled]="!affCodeMassAddComponent?.selectedAffCode"
        icon="pi pi-plus"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelAffCodeAdd()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [visible]="showAffCodeRemoveDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <ng-template pTemplate="header">
    {{ 'profiles.search.affcode-remove-header' | translate }}
  </ng-template>
  <wl-affcode-mass-add #wlAffCodeMassRemove hideTypes="true" showButtons="false"></wl-affcode-mass-add>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massRemoveAffCodes()"
        [disabled]="!affCodeMassRemoveComponent?.selectedAffCode"
        icon="pi pi-minus"
        [label]="'common.remove' | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelAffCodeRemove()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [visible]="showEdit"
  [modal]="true"
  [closable]="false"
  styleClass="atlas-dialog-xl"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <wl-profile-edit [preventLoad]="true" [hideSaveButtons]="true" [isModal]="true"></wl-profile-edit>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn btn-default mr-10"
      (click)="closeEdit()"
      [label]="'common.cancel' | translate | uppercase"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="saveOpenProfile()"
      [disabled]="isSaving || profileEditComponent?.isLoading"
    >
      <span *ngIf="!isSaving && !profileEditComponent?.isLoading">{{
        'profiles.view.add-member.save-and-close' | translate | uppercase
      }}</span>
      <wl-busy [show]="isSaving || profileEditComponent?.isLoading"></wl-busy>
    </button>
  </ng-template>
</p-dialog>

<p-dialog [visible]="showAssignMembershipLevelDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <ng-template pTemplate="header">
    {{ 'profiles.search.assign-to-membership-header' | translate }}
  </ng-template>
  <p-select
    placeholder="{{ 'common.select' | translate | titlecase }}"
    [options]="membershipLevels"
    [style]="{ width: '100%' }"
    [(ngModel)]="selectedMembershipLevelId"
    appendTo="body"
  >
  </p-select>
  <p class="mt-2">{{ 'profiles.search.assign-to-membership-note' | translate }}</p>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massAssignMembershipLevels()"
        [disabled]="selectedMembershipLevelId == 0"
        [label]="'profiles.search.assign-membership-level' | translate | uppercase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelAssignMembershipLevels()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | uppercase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showCreateMemberActivityDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
  <ng-template pTemplate="header">
    {{ 'profiles.search.create-activity-header' | translate | titlecase }}
  </ng-template>
  <wl-member-activity-search-action #memberActivityAction></wl-member-activity-search-action>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massCreateMemberActivity()"
        [disabled]="!memberActivityAction.valid"
      >
        {{ 'profiles.search.create-member-activities' | translate | uppercase }}
      </button>
      <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelCreateActivity()"> </cancel-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [visible]="showAssignUserDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s">
  <ng-template pTemplate="header">{{ 'profiles.search.assign-user-header' | translate | titlecase }}</ng-template>
  <wl-assign-user-search-action #assignUserAction></wl-assign-user-search-action>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massAssignUser()"
        [disabled]="assignUserAction.selectedUserId == 0"
        [label]="'profiles.search.assign-user' | translate | uppercase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelAssignUser()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | uppercase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showSetStatusDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s">
  <ng-template pTemplate="header">{{ 'profiles.search.set-profile-status' | translate | titlecase }}</ng-template>
  <wl-set-status-search-action #setStatusAction></wl-set-status-search-action>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massSetStatus()"
        [disabled]="setStatusAction.selectedStatusId == 0"
        [label]="'profiles.search.set-profile-status' | translate | uppercase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelSetStatus()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | uppercase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [visible]="showCreateContactDialog" [modal]="true" [closable]="false" styleClass="atlas-dialog-s">
  <ng-template pTemplate="header">{{ 'profiles.search.create-profile-contact-header' | translate | titlecase }}</ng-template>
  <wl-create-contact-search-action #createContactAction></wl-create-contact-search-action>
  <ng-template pTemplate="footer">
    <div class="mct-flex-gt-md mct-row-gt-md mct-justify-end mct-items-center mct-gap-10">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="massCreateContact()"
        [disabled]="!createContactAction.valid"
        [label]="'profiles.search.create-contact-records' | translate | uppercase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="cancelCreateContact()"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | uppercase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<wl-create-task-search-action></wl-create-task-search-action>
<wl-add-referral-dialog></wl-add-referral-dialog>
